import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { show } from '@frontend/utils/dom';
import { dispatchCustomEvent } from '@frontend/utils/events';

export const HEADER_CLICKED_EVENT = 'article--teaser--component:header-clicked';

export default class extends Controller {
  static targets = ['specialNumber'];
  static values = {
    articleId: Number,
  };

  connect() {
    if (CurrentUser.isAuthor()) {
      show(this.specialNumberTarget);
    }
  }

  headerClicked(event) {
    if (event.target.closest('a, button, input')) return;

    dispatchCustomEvent(HEADER_CLICKED_EVENT, { teaser: this.element });
  }
}
